<style lang="scss" scoped>
.headBar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
  min-width: 1200px;
  display: flex;
  justify-content: space-between;
  padding: 0 35px 0 24px;
  line-height: 50px;
  margin-bottom: 24px;
  .title {
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #444;
    .left {
      color: #0171c2;
    }
    .right {
    }
  }
  .userInfo {
    img {
      width: 30px;
      height: 30px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
    }
  }
}
</style>
<template>
  <div class="headBar">
    <div class="title">
      <span class="left">云店营销中心</span>
      <!-- <span style="color: e5e5e5"> ｜ </span> -->
      <!-- <span class="">这里是刚才授权的企业名</span> -->
    </div>
    <div class="userInfo view-flex">
      <div
        style="margin-right: 10px; width: 30px; height: 30px; border-radius: 50%; margin-top: 8px"
      >
        <img
          style="width: 100%; height: 100%; border-radius: 50%"
          :src="qwCompanyInfo.user_info.avatar || require(`@/assets/img/salesperson/logo.jpg`)"
          alt=""
        >
      </div>
      <span>{{ qwCompanyInfo.user_info.name || '用户名' }}</span>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'HeadBar',
  props: {
    qwCompanyInfo: {
      type: Object,
      default: () => {
        return {
          corp_info: {},
          user_info: {}
        }
      }
    }
  },
  data () {
    return {}
  },
  watch: {},
  mounted () {
    console.log('head-qwCompanyInfo', this.qwCompanyInfo)
  },
  methods: {}
}
</script>
